import { createContext, useContext, useState, useEffect } from "react";
import api from "../apis/Interceptor";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restore token from localStorage on initial load
    const token = localStorage.getItem("accessToken");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    const fetchUser = async () => {
      try {
        const res = await api.get("/auth/me", { withCredentials: true });
        setUser(res.data);
        setIsAuthenticated(true);
      } catch (err) {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem("accessToken");
        delete api.defaults.headers.common["Authorization"];
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = (userData, accessToken) => {
    setIsAuthenticated(true);
    setUser(userData);
    api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    localStorage.setItem("accessToken", accessToken);
  };

  const logout = async () => {
    setIsAuthenticated(false);
    setUser(null);
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("accessToken");
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, loading, logout, login }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
